// extracted by mini-css-extract-plugin
export var menu = "index-module--menu--N9jNb";
export var content = "index-module--content--xmtra";
export var fadein = "index-module--fadein--GjsI4";